import React, {useEffect} from 'react'
import OdxIcon from './Odx-Icon'
import {odxIconSets} from '../constants'

interface OdxToastProps {
    isDismissible: boolean,
    variant: "success" | "danger" | "warning" | "default",
    message: string,
    onDismiss?: () => void,
    title: string,
    duration?: number
}

const OdxToast: React.FC<OdxToastProps> = ({isDismissible, message, variant, onDismiss, title, duration}) => {

    useEffect(() => {
        if (duration && duration > 0) {
            setTimeout(() => {
                if (onDismiss) onDismiss();
            }, duration);
        }
    }, []);

    return <>
        {/*<div className={"odx-toast-container"}>*/}
        <div className={`odx-toast-item--${variant} odx-toast-item ng-star-inserted`}>
            <div className="odx-toast-item__content OdxToastClassMarkerForFrontendTests">
                {(() => {
                    switch (variant) {
                        case "success":
                            return <OdxIcon name={"check"} size={"md"} iconSet={odxIconSets.core}/>;
                        case "danger":
                            return <OdxIcon name={"error"} size={"md"} iconSet={odxIconSets.core}/>;
                        case "warning":
                            return <OdxIcon name={"warning"} size={"md"} iconSet={odxIconSets.core}/>;
                        case "default":
                            return <OdxIcon name={"info"} size={"md"} iconSet={odxIconSets.core}/>;
                        default:
                            return <OdxIcon name={"error"} size={"md"} iconSet={odxIconSets.core}/>;
                    }
                })()}

                <div className="odx-toast-item__text-content">
                    <p className="odx-toast-item__title OdxToastTitleClassMarkerForFrontendTests">{title}</p>

                    <p className="odx-toast-item__description ng-star-inserted OdxToastMessageClassMarkerForFrontendTests">
                        {message}
                    </p>
                </div>
                {isDismissible && (
                    <odx-icon-button
                        className="OdxToastRemoveBtnClassMarkerForFrontendTests"
                        variant="ghost"
                        icon={`${odxIconSets.core}::close`}
                        size="sm"
                        onClick={() => onDismiss && onDismiss()}
                    />
                )}
            </div>
        </div>
        {/*</div>*/}
    </>
}

export default OdxToast;
